import Vue from 'vue';
import Vuex from 'vuex';
// import VuexPersist from 'vuex-persist';
import createPersistedState from 'vuex-persistedstate';
import mutations from './mutations';
import auth from './auth';
import division from './division';
import profile from './profile';
import brand from './brand';
import position from './position';
import entity from './entity';
import department from './department';
import house from './house';
import budget from './budget';
import taxonomy from './taxonomy';
import costGroup from './costGroup';
import productHierarchy from './productHierarchy';
import costCenter from './costCenter';
import costElement from './costElement';
import spending from './spending';
import stage from './stage';
import costCategory from './costCategory';
import costConsumer from './costConsumer';
import pagination from './pagination';
import configuration from './configuration';
import dashboard from './dashboard';
import advanceFilter from './advanceFilter';
import purchasingOrder from './purchasingOrder';
import onePager from './onePager';
import budgetMovement from './budgetMovement';
import unit from './unit';
import keyHighlight from './keyHighlight';
import sshcf from '@/store/sshcf';
import docs from './contentManagement/docs';
import notification from './notification';
import texts from './contentManagement/texts';
import guidelineMenu from './contentManagement/menu';
import mroi from './mroi';
import monthlyReport from './monthlyReport';
import powerBI from '@/store/powerBI';
import auditTrail from './auditTrail';
import support from './contentManagement/support';
import category from './category';
import contentPortal from './financialPortal/contentPortal';
import categoryPortal from './financialPortal/category';
import dynamic from './dynamic';
import approval from './dynamic/approval';
import spendingDynamic from './dynamic/spending';
import budgetDynamic from './dynamic/budget';
import channel from './channel';
import sshcp from '@/store/sshcp';
import investmentType from './investmentType';

Vue.use(Vuex);

// Initialize VuexPersist:
// const vuexPersist = new VuexPersist({
//   key: 'vuex-nav',
//   storage: localStorage
// });

export default new Vuex.Store({
  modules: {
    mutations,
    auth,
    division,
    profile,
    brand,
    position,
    entity,
    department,
    house,
    budget,
    taxonomy,
    costGroup,
    productHierarchy,
    costCenter,
    costElement,
    spending,
    stage,
    costCategory,
    costConsumer,
    pagination,
    configuration,
    dashboard,
    advanceFilter,
    purchasingOrder,
    onePager,
    budgetMovement,
    unit,
    keyHighlight,
    docs,
    texts,
    sshcf,
    notification,
    mroi,
    monthlyReport,
    powerBI,
    guidelineMenu,
    auditTrail,
    support,
    category,
    contentPortal,
    categoryPortal,
    dynamic,
    approval,
    spendingDynamic,
    budgetDynamic,
    channel,
    sshcp,
    investmentType
  },
  // Load Plugins
  // plugins: [vuexPersist.plugin]
  plugins: [
    createPersistedState({
      paths: ['auth.isLoggedIn', 'auth.userRole']
    })
  ]
});
